import { ListView, ListViewDir } from "./listview"

const { ccclass, property } = cc._decorator;

@ccclass
export default class ListView_Demo extends cc.Component {

    @property(cc.ScrollView)
    scrollview: cc.ScrollView = null;

    @property(cc.Node)
    view: cc.Node = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;

    m_list: ListView = null

    onLoad() {
        let list: ListView = new ListView({
            scrollview: this.scrollview,
            view: this.view,
            content: this.content,
            item_prefab: this.prefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            select_cb: this.on_item_select,
            column: 2,
            row: 5,
            gap_y: 2,
            direction: ListViewDir.Vertical,
        });

        let length = 100
        let datas = []
        for (let i = 0; i < length; i++) {
            datas.push("我是第" + i + "条数据！")
        }
        this.m_list = list
        list.set_data(datas);
        list.select_item(55)
        list.scroll_to(55)

    }

    on_item_select(data: any, index: number) {
        cc.log(data, index);
    }

    update_list_item(item: cc.Node, data: any, index: number): void {
        item.getComponent(cc.Label).string = data.toString();
        if (index == this.m_list.selected_index) {
            item.color = cc.Color.RED
        } else {
            item.color = cc.Color.WHITE
        }
    }
}
